import { useState } from 'react';
import instagram from '../imgs/instagram.png';
import facebook from '../imgs/facebook.png';
import LogoKJ from '../imgs/logo.png';
import { Link } from 'react-scroll';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function Navbar() {
    const [activeLink, setActiveLink] = useState('header-kj');

    function redirectToLoginPage() {
        window.open('https://app.kj-logistics.com/', '_blank');
    }

    return (
        <div className='full-navbar'>
            <div id='top-navbar'>
                <span className='text-topnavbar'>
                    <p data-aos="fade-down">
                        <i className="bi bi-telephone-fill"></i> 55 3443 9138 o 442 170 8516
                    </p>
                    <p data-aos="fade-down">
                        <i className="bi bi-envelope-at-fill"></i> operaciones@kj-logistics.com
                    </p>
                    <p className='redes'>
                        <a href="https://www.instagram.com/kj_logistics/" target="_blank" rel="noreferrer">
                            <img src={instagram} alt="insta" height='15' data-aos="fade-down" data-aos-delay="200" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=100064372291202" target="_blank" rel="noreferrer">
                            <img src={facebook} alt="fb" height='15' data-aos="fade-down" data-aos-delay="400" />
                        </a>
                    </p>
                    <p className='right-align' data-aos="fade-down" onClick={redirectToLoginPage}>
                        <i className="bi bi-box-arrow-in-right"></i> Inicia sesión
                    </p>
                </span>
            </div>

            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid justify-content-between">
                    <a
                        className="navbar-brand"
                        href="#inicio"
                        data-aos="zoom-in"
                        data-aos-duration="2000"
                    >
                        <img src={LogoKJ} alt="logo-kj" height='50' />
                    </a>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            {[
                                { to: 'header-kj', label: 'Inicio', delay: 100 },
                                { to: 'quienes-somos', label: '¿Quiénes somos?', delay: 200 },
                                { to: 'servicios', label: 'Nuestros Servicios', delay: 300 },
                                { to: 'cobertura-aduanal', label: 'Cobertura Aduanal', delay: 400 },
                                { to: 'nuestro-valor', label: 'Nuestro Valor', delay: 500 },
                                { to: 'contacto', label: 'Contacto', delay: 600 },
                            ].map(({ to, label, delay }) => (
                                <li
                                    className="nav-item"
                                    key={to}
                                    data-aos="zoom-in"
                                    data-aos-delay={delay}
                                >
                                    <Link
                                        activeClass={activeLink === to ? 'active' : ''}
                                        className="nav-link"
                                        to={to}
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-120}
                                        onSetActive={(to) => setActiveLink(to)}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </nav>

            <div className='navbar-spacer'></div>
        </div>
    );
}

export default Navbar;